<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="1"
      loader="bars"
    ></loading>
    <div class="container-scroller" style="background: #f9fafb">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="vh-100 content-wrapper auth-wrapper d-flex no-block d-flex justify-content-center align-items-center auth auth-img-bg"
        >
          <div class="row-login flex-grow">
            <div class="col-12">
              <div class="auth-form-transparent">
                <div class="brand-logo" align="center">
                  <img
                    src="../../assets/images/logo.png"
                    alt="logo"
                    height="45"
                  />
                </div>

                <div v-if="mssg">
                  <div>
                    <div align="center">
                      <h5 class="pt-3" style="font-size: 26px">
                        {{ $t("email.verification") }}
                      </h5>
                    </div>
                    <div align="center" class="text-center margin-bottom-1x">
                      <p class="gray4 text-center mx-auto w-75">
                        {{ $t("email.verify_caption") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="Errormssg"
                  align="center"
                  class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ Errormssg }}
                  </p>
                </div>

                <button
                  v-if="Errormssg || mssg"
                  class="btn btn-primary mt-3"
                  @click="goToLogin"
                >
                  {{ $t("email.go_to_login") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Login",
  data() {
    return {
      validToken: false,
      mssg: "",
      Errormssg: "",
      isLoading: true,
      fullPage: true,
    };
  },
  mounted() {
    this.verifyMail({ token: this.$route.params.token })
      .then((res) => {
        this.validToken = true;
        this.isLoading = false;
        if (res.data.success) {
          this.mssg = res.data.payload.message;
        }
        console.log(res);
        console.log(this.mssg);
        console.log(res.data.payload.message)
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg = error.response.data.message;
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  components: {
    Loading,
  },
  methods: {
    ...mapActions(["verifyMail"]),
    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
